import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ArrowRightIcon } from '@mui/x-date-pickers-pro';

import InfoTooltipIcon from 'components/InfoTooltipIcon';

import useStyles from './styles';

type Props = {
  id: string;
  text: string;
  infoText?: string;
  onClick: () => void;
};

const TaxNavButton = ({ id, text, infoText, onClick }: Props) => {
  const { classes } = useStyles();

  return (
    <Stack id={`${id}-btn`} direction='row' alignItems='center' justifyContent='flex-end'>
      {infoText && <InfoTooltipIcon size='small-no-padding' tooltipText={infoText} />}
      <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={onClick}>
        <Typography variant='paragraphMedium' className={classes.taxInfoBtn}>
          {text}
        </Typography>
        <ArrowRightIcon className={classes.arrow}></ArrowRightIcon>
      </Box>
    </Stack>
  );
};

export default TaxNavButton;
